export const ADD_BLOG = "ADD_BLOG";
export const ADD_BLOG_ERR = "ADD_BLOG_ERR";
export const DELETE_BLOG = "DELETE_BLOG";
export const DISPLAY_BLOG = "DISPLAY_BLOG";
export const GET_BLOGS = "GET_BLOGS";
export const GET_BLOG = "GET_BLOG";
export const PUBLISH_BLOG = "PUBLISH_BLOG";
export const TOTAL_BLOG = "TOTAL_BLOG";
export const GET_RELATED_PRODUCT = "GET_RELATED_PRODUCT";
export const SET_RELATED_POPUP_VISIBLE = "SET_RELATED_POPUP_VISIBLE";
export const BLOG_SHARE = "BLOG_SHARE";
export const CONTENT_POPUP_VISIBLE = "CONTENT_POPUP_VISIBLE";
